import { FilteredProductsResponse } from '@/entities/api/products/product-filters'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ProductsSlice {
	promoProducts?: Partial<FilteredProductsResponse>
	supplementsProducts?: Partial<FilteredProductsResponse>
	clothesProducts?: Partial<FilteredProductsResponse>
	accessoriesProducts?: Partial<FilteredProductsResponse>
	plansProducts?: Partial<FilteredProductsResponse>
}

const initialState: ProductsSlice = {
	promoProducts: {},
	supplementsProducts: {},
	clothesProducts: {},
	accessoriesProducts: {},
	plansProducts: {},
}

const ProductSlice = createSlice({
	name: 'products',
	initialState,
	reducers: {
		setPromoProducts: (
			state,
			action: PayloadAction<Partial<FilteredProductsResponse>>
		) => {
			state.promoProducts = action.payload
		},
		setSupplementsProducts: (
			state,
			action: PayloadAction<Partial<FilteredProductsResponse>>
		) => {
			state.supplementsProducts = action.payload
		},
		setClothesProducts: (
			state,
			action: PayloadAction<Partial<FilteredProductsResponse>>
		) => {
			state.clothesProducts = action.payload
		},
		setAccessoriesProducts: (
			state,
			action: PayloadAction<Partial<FilteredProductsResponse>>
		) => {
			state.accessoriesProducts = action.payload
		},
		setPlansProducts: (
			state,
			action: PayloadAction<Partial<FilteredProductsResponse>>
		) => {
			state.plansProducts = action.payload
		},
		clearAllProducts: (state) => {
			state.promoProducts = {}
			state.supplementsProducts = {}
			state.clothesProducts = {}
			state.accessoriesProducts = {}
			state.plansProducts = {}
		},
	},
})

export const {
	setPromoProducts,
	setSupplementsProducts,
	setClothesProducts,
	setAccessoriesProducts,
	setPlansProducts,
	clearAllProducts,
} = ProductSlice.actions

export default ProductSlice.reducer
